import { render, staticRenderFns } from "./PasswordRemindCheckCode.vue?vue&type=template&id=49cef6c3&scoped=true&"
import script from "./PasswordRemindCheckCode.vue?vue&type=script&lang=ts&"
export * from "./PasswordRemindCheckCode.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordRemindCheckCode.vue?vue&type=style&index=0&id=49cef6c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cef6c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VForm,VImg,VRow,VTextField})
